export default __webpack_public_path__ + "static/media/destroyed_26@2x.4aef9747.png";